import PreventFirstScroll from './Modules/PreventFirstScroll.js';
import * as FvAnime from './Modules/FvAnime.js';
import * as ScrollLock from './Modules/ScrollLock.js';
import * as CvVisible from './Modules/CvVisible.js';

const preinit = () => {
  // ScrollLock.on();
  // PreventFirstScroll();
}

const init = () => {
  FvAnime.init();
  CvVisible.init();
}

const resize = () => {
  CvVisible.check();
  FvAnime.check();
}

const resizeW = () => {

}

const scroll = () => {
  CvVisible.check();
  FvAnime.check();
}

const load = () => {
  FvAnime.load();
}

export {
  preinit,
  init,
  resize,
  resizeW,
  scroll,
  load
}